import { Line, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins;

const graphConfig = {
  responsive: true,
  legend: {
    display: false,
    position: 'bottom',
    onClick: null
  },
  tooltips: {
    enabled: false
  },
  elements: {
    point: {
      borderWidth: 0,
      radius: 0,
      hoverRadius: 0,
      hoverBorderWidth: 0
    }
  },
  scales: {
    xAxes: [
      {
        display: false,
        gridLines: {
          display: false,
          drawBorder: false
        }
      }
    ],
    yAxes: [
      {
        display: false,
        gridLines: {
          display: false,
          drawBorder: false
        }
      }
    ]
  }
};

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ['chartData', 'options'],
  mounted() {
    // @ts-ignore
    this.renderChart(this.chartData, {
      ...graphConfig,
      // @ts-ignore
      ...this.options
    });
  }
};
